import { ThreeDots } from "react-loader-spinner";
import { LoaderContainer } from "./Loader.styled";

export const Loader = () => {
  return (
    <LoaderContainer>
      <ThreeDots
        visible={true}
        height="80"
        width="80"
        color="#559AEE"
        radius="9"
        ariaLabel="three-dots-loading"
      />
    </LoaderContainer>
  );
};
